// src/utils/helpers.js
  // Animation helpers using the Intersection Observer API
  export const createObserver = (callback, options = {}) => {
    return new IntersectionObserver(callback, {
      root: null,
      threshold: 0.1,
      rootMargin: '0px',
      ...options
    });
  };
  
  // Reveal animations for elements when they come into view
  export const setupRevealAnimations = () => {
    const revealElements = document.querySelectorAll('.reveal');
    
    const revealCallback = (entries, observer) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('active');
          observer.unobserve(entry.target);
        }
      });
    };
    
    const revealObserver = createObserver(revealCallback);
    
    revealElements.forEach(element => {
      revealObserver.observe(element);
    });
  };
  
  // Format date for display
  export const formatDate = (dateString) => {
    const options = { year: 'numeric', month: 'long', day: 'numeric' };
    return new Date(dateString).toLocaleDateString('en-US', options);
  };
  
  // Truncate text to a specific length
  export const truncateText = (text, maxLength) => {
    if (text.length <= maxLength) return text;
    return text.slice(0, maxLength) + '...';
  };
  
  // Generate random ID
  export const generateId = (prefix = 'id') => {
    return `${prefix}-${Math.random().toString(36).substring(2, 9)}`;
  };
  
  // Debounce function for scroll and resize events
  export const debounce = (func, wait = 100) => {
    let timeout;
    return function(...args) {
      clearTimeout(timeout);
      timeout = setTimeout(() => {
        func.apply(this, args);
      }, wait);
    };
  };
  
  // Validate email format
  export const isValidEmail = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  };